import { Badge } from '@mantine/core';
import { useLlmStreamController } from '../../controllers/useLlmStreamController';

/**
 * Бейдж на иконке дока ассистента.
 * Показывает состояние при ЗАКРЫТОЙ панели, чтобы юзер не пропустил:
 * - «?» — ассистент ждёт ответа пользователя (HITL-пауза);
 * - «…» — идёт генерация ответа.
 * Возвращает null, когда ассистент бездействует.
 */
export function AssistantDockBadge() {
  const isLoading = useLlmStreamController(s => s.isLoading) as boolean;
  const hasPending = useLlmStreamController(s => s.pendingUserInput !== null) as boolean;

  if (hasPending) {
    return (
      <Badge size='xs' color='yellow' variant='filled'>
        ?
      </Badge>
    );
  }
  if (isLoading) {
    return (
      <Badge size='xs' color='blue' variant='filled'>
        …
      </Badge>
    );
  }
  return null;
}
